import React from "react";

const Avatar = ({ name, src, size = "md", showTooltip = false }) => {
  const getInitials = (name) => {
    if (!name?.trim()) return "?";

    const parts = name
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    if (parts.length >= 2) {
      return (
        parts[0][0] +
        parts[parts.length - 1][0]
      ).toUpperCase();
    }

    return parts[0].slice(0, 2).toUpperCase();
  };

  const sizeClasses = {
    sm: "w-8 h-8 text-xs",
    md: "w-10 h-10 text-sm",
    lg: "w-12 h-12 text-base",
  };

  const getColorFromName = (name) => {
    if (!name) return "bg-gray-400";
    const colors = [
      "bg-blue-500",
      "bg-green-500",
      "bg-yellow-500",
      "bg-red-500",
      "bg-purple-500",
      "bg-pink-500",
      "bg-indigo-500",
      "bg-teal-500",
    ];
    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  };

  const avatarContent = (
    <div
      className={`${sizeClasses[size]} rounded-full flex items-center justify-center text-white font-medium ${src ? "" : getColorFromName(name)
        } overflow-hidden`}
      title={showTooltip ? name : ""}
    >
      {src ? (
        <img src={src} alt={name} className="w-full h-full object-cover" />
      ) : (
        <span>{getInitials(name)}</span>
      )}
    </div>
  );

  return avatarContent;
};

export default Avatar;
